import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=51edb8e2&scoped=true&"
import script from "./AdminEdit.vue?vue&type=script&lang=ts&"
export * from "./AdminEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AdminEdit.vue?vue&type=style&index=0&id=51edb8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51edb8e2",
  null
  
)

export default component.exports